import { required, SelectInput, Validator } from 'react-admin';

import {
  b2bRecurringInvestmentFrequencyChoices,
  b2bRecurringInvestmentPayerChoices,
} from '@sh4res/bo-common/choices/recurring_investments';
import { ShowSection } from '@sh4res/bo-common/components';
import { AffiliateInformationSection } from '@sh4res/bo-common/components/B2bVoluntaryPayment/steps/GeneralInfoStep';
import { RadioButtonGroupInput } from '@sh4res/bo-common/components/RadioButtonGroupInput';
import { DateInput } from '@sh4res/bo-common/fields/DateInput';

const testId = 'BoExternalB2bRecurringInvestmentCreateGeneralInfoStep';

const getToday = () => {
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

const notBeforeToday: Validator = (value) =>
  value && value < getToday()
    ? 'resources.bo_common.b2b.recurring_investments.create.messages.start_date_in_past'
    : undefined;

export const recurringInvestmentTypeChoices = [
  {
    id: 'recurring_voluntary_payment',
    name: 'resources.bo_common.b2b.recurring_investments.create.type',
  },
];

export const RecurringInvestmentGeneralInfoStep = () => (
  <>
    <AffiliateInformationSection />
    <ShowSection
      leftAligned
      label="resources.bo_common.b2b.voluntary_payment_create.sections.type"
      subtitle="resources.bo_common.b2b.recurring_investments.create.type_subtitle"
      noCard={true}>
      <RadioButtonGroupInput
        data-testid={`${testId}_TypeInput`}
        source="type"
        choices={recurringInvestmentTypeChoices}
        required
      />
      <SelectInput
        data-testid={`${testId}_PayerInput`}
        source="payer"
        label="resources.bo_common.b2b.recurring_investments.fields.payer"
        choices={b2bRecurringInvestmentPayerChoices}
        validate={[required()]}
      />
      <DateInput
        data-testid={`${testId}_StartDateInput`}
        source="start_date"
        label="resources.bo_common.b2b.recurring_investments.fields.execution_starting_date"
        validate={[required(), notBeforeToday]}
        inputProps={{ min: getToday() }}
      />
      <SelectInput
        data-testid={`${testId}_FrequencyInput`}
        source="frequency"
        label="resources.bo_common.b2b.recurring_investments.fields.execution_frequency"
        choices={b2bRecurringInvestmentFrequencyChoices}
        validate={[required()]}
      />
    </ShowSection>
  </>
);
